export default {"src":"/_next/static/media/redacto-news-letter.4902726c.svg","height":285,"width":319,"blurWidth":0,"blurHeight":0};